import { gql } from "@apollo/client";

export const UPDATE_UNIT_MODE = gql`
  mutation UpdateUnitMode($unitId: ID!, $mode: String!) {
    updateUnitMode(unitId: $unitId, mode: $mode) {
      _id
      mode
      title
      level
      timer
      _book
      _sections
      _image {
        _id
        src
      }
      isHidden
    }
  }
`;
